module.exports = __webpack_public_path__ + "img/icon_map_3_hg_c.6ebcbf57.png";